module.exports = __webpack_public_path__ + "static/media/nextArrow.dce241aa.svg";